module.exports = __webpack_public_path__ + "media/images/home/ic_note-5ffc3ada602f0a735b5505021a1d2df0.svg";